import React, { Component } from 'react';
import 'ag-grid-community/styles/ag-theme-balham.css';
import '../index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import PropTypes from 'prop-types';
import 'ag-grid-community/styles/ag-grid.css';
import { getDateFormat, getOnlyValues } from '../../claims/common';
import { convertUnixtodate } from '../../shared/services/common-functions';
import { getFactoryByCode } from '../../app/common/repositories';
import { filterEmpty } from '../../shared/services/validator';
import { WarningAlertBar } from '../../shared/components/alert-bar';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import { AgGridReact } from 'ag-grid-react';
// import Checkbox from '../../shared/components/checkbox';
import agcmdlColumnDefinitions from '../../claims/components/column-defination-agcmdl-view';
import { getClaimDetailsPDF } from '../repositories';
import _ from 'lodash';
// import { createErrorMessage } from '../../shared/action-creator/alert-messages';
import { customizeErrorAlert } from '../../shared/services/customize-error-alert-bar';


const rowSelection = 'multiple';
const rowClick = 'single';

class agcmdldetails extends Component {

    state = {

        selectedGridRow: {},
        factory: '',
        productSeriesIds: '',
        productSubSeriesIds: '',
        baseCodeIds: '',
        regionCode: '',
        branchIds: [],
        warningAlertOpen: true,
        selectedAll: false,
    };

    componentWillMount = () => {

        this.props.editedInputs.map( item => {

            switch ( item[0] ) {

            case 'factoryCode': this.getFactoryByCode( item[1] ); break;
            case 'productSeriesIds':
            case 'productSubSeriesIds':
            case 'baseCodeIds':
            case 'factoryClaimTypeIds':
            case 'branchIds': this.updateState( item[0], getOnlyValues( item[1] ) ); break;
            case 'regionCode': this.updateState( 'regionCode', item[1] ); break;
            default: break;

            }
            return true;

        } );

    }

    onGridReady = params => {

        const columnsToBeHide = [];
        const allColumnIds = [];
        const searchViewOption = this.props.searchedOptions;
        this.gridApi = params.api;
        this.columnApi = params.columnApi;

        try {

            this.gridApi.context.beanWrappers.tooltipManager
                .beanInstance.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT = 0;

        } catch ( e ) {}

        if ( !searchViewOption.includeComplaintCauseCorrection ) {

            columnsToBeHide.push( 'language', 'complaint', 'cause', 'correction', 'lastClaimNumber' );

        }
        if ( !searchViewOption.includeRejects ) {

            columnsToBeHide.push( 'claimStatusCode' );

        }
        if ( !searchViewOption.include17CharacterPin ) {

            columnsToBeHide.push( 'pin.digit17' );

        }

        if ( !searchViewOption.includeAttachmentCount ) {

            columnsToBeHide.push( 'attachmentCount' );

        }
        if ( this.columnApi && this.columnApi.setColumnsVisible ) {

            this.columnApi.setColumnsVisible( columnsToBeHide, false );

        }

        const columns = this.columnApi && this.columnApi.getAllColumns ?
            this.columnApi.getAllColumns() : [];

        columns.forEach( column => {

            allColumnIds.push( column.colId );

        } );

        if ( this.columnApi && this.columnApi.autoSizeColumns && allColumnIds.length > 0 ) {

            this.columnApi.autoSizeColumns( allColumnIds, true );

        }
       // this.gridApi.addEventListener('cellClicked', this.handleClaimNumberClick);

        this.props.updateGridAPI( this.gridApi );
        this.gridApi.addEventListener('cellClicked', (params) => {
            if (params.column.colDef.field === 'claimNumber') {
              this.props.onClaimDetails(params.node.rowIndex);
            }
          });

    };
    // handleClaimNumberClick = (params) => {
    //     console.log('Claim number clicked:', params.value);
    //     if (params.column.colDef.field === 'claimNumber') {
    //         console.log('Claim number clicked:', params.value);
    //         // Add your custom logic here
    //        // this.props.onClaimDetails(params.value);
    //        this.props.onClaimDetails(params.node.rowIndex);
    //     }
    // };

    // componentWillUnmount() {
    //     if (this.gridApi) {
    //         this.gridApi.removeEventListener('cellClicked', this.handleClaimNumberClick);
    //     }
    // }

    
    onSelectionChanged() {
        const selectedRows = this.gridApi.getSelectedRows();
        let selectedRowsString = '';
        selectedRows.forEach( ( selectedRow, index ) => {
            if ( index !== 0 ) {
                selectedRowsString += ', ';
            }
            selectedRowsString = selectedRow;
        });
        this.setState({
            selectedGridRow: selectedRowsString,
        });
        console.log("selectedRowsString *****",this.state.selectedGridRow);
    }

    onBtExport () {
        const exportColumnDefs = agcmdlColumnDefinitions.filter((colDef, index) => index !== 0);

        this.gridApi.exportDataAsCsv( {
            columnKeys: exportColumnDefs.map(colDef => colDef.field),
            processCellCallback: function convertToDate ( cell ) {

                let cellVal = cell.value;
              //  console.log(cell.column.colDef.headerName);
                if (cell.column.colDef.headerName !== "All") {
                  //  console.log("cell.column.colDef",cell);

                    if ( cell.column.colDef.valueFormatter ) {

                    cellVal = cellVal ? convertUnixtodate( cellVal ) : '';

                    }
                    return cellVal;
            }
            return '';

            },

        } );

    }
    // onBtExportPDF () {

    //     const selectedRows = this.gridApi.getSelectedRows();
    //     const columns = this.gridColumnApi.getAllColumns().map(column => column.colDef.headerName);
    //     const rows = selectedRows.map(row => {
    //         const cells = [];
    //         this.gridColumnApi.getAllColumns().forEach(column => {
    //             const field = column.colDef.field;
    //             cells.push(row[field]);
    //         });

    //         return cells;
    //     });
    //     console.log("rows ",rows);


    // }
    ClaimDetailsPDFDownload = ( payload ) => {

            this.props.increaseCounter();
            getClaimDetailsPDF(payload).then( response => {
    
                this.props.decreaseCounter();
    
            } ).catch( () => {
    
                this.props.decreaseCounter();
    
            } );

            
    
        }
        
    onBtExportPDF() {
        const selectedRows = this.gridApi.getSelectedRows();
        console.log("selectedRows on pdf click",selectedRows);
        if(selectedRows.length > 0){
        const wrntyClaimSeqLst =    _.map(selectedRows, 'warrantyClaimId');
        console.log("wrntyClaimSeqLst::: ",wrntyClaimSeqLst);
        this.ClaimDetailsPDFDownload( wrntyClaimSeqLst );
        }else{
            console.log("claims not selected!!");
            console.log("selectedAll,",this.state.selectedAll);
            customizeErrorAlert("Please select claims to proceed!")
        }

        // const columns = this.gridColumnApi.getAllColumns().map(column => column.colDef.headerName);
        // const rows = selectedRows.map(row => {
        //   const cells = [];
        //   this.gridColumnApi.getAllColumns().forEach(column => {
        //     const field = column.colDef.field;
        //     cells.push(row[field]);
        //   });
        //   return cells;

      
        // });

        // console.log("rows$$$ ",rows);
      
        // const doc = new jsPDF("l", "mm", "a4");
        // doc.autoTable({
        //   head: [columns],
        //   body: rows,
        //   theme: "striped",
        //   styles: { cellWidth: "wrap" },
        //   headStyles: { fillColor: [128, 128, 128] },
        // });
      
        // doc.save("claim-details.pdf");
      }
    onModify () {

        this.props.onEditSearch();

    }


    onClear () {

        this.props.onNewSearch();

    }

    updateState = ( propertyName, propertyValue ) => {

        this.setState( {
            [propertyName]: propertyValue,
        } );

    }


    getFactoryByCode = factoryCode => {

        if ( factoryCode !== '-1' ) {

            getFactoryByCode( factoryCode ).then( response => {

                this.updateState( 'factory', response.factoryDescription );

            } );

        }

    }

    onSelectAll(event) {
        this.setState({ selectedAll: event.target.checked });
        if (event.target.checked) {
            this.gridApi.selectAll();
        } else {
            this.gridApi.deselectAll();
        }
    }

    onRowCheckboxChanged(event) {
        if (!event.node.selected) {
            this.setState({ selectedAll: false });
        } else {
            const selectedRowCount = this.gridApi.getSelectedNodes().length;
            const totalRowCount = this.gridApi.getDisplayedRowCount();
            this.setState({ selectedAll: selectedRowCount === totalRowCount });
        }
    }

    // onClaimClick = element => {
        
    //     const elementName = element.event.target.name;
    //     console.log("on claim clicked***",elementName);
    //     console.log("element.node.rowIndex***",element.node.rowIndex);
    //     if ( elementName ) this.props.onClaimDetails( element.node.rowIndex );

    // }

    onClaimClick = element => {

        const elementName = element.event.target.name;
        console.log("on claim clicked***",elementName);
        console.log("element.node.rowIndex***",element.node.rowIndex);
        if ( elementName ) this.props.onClaimDetails( element.node.rowIndex );

    }
    

    getSearchedValue = ob => {

        const searchedVal = ob[1];
        const searchedName = ob[0];

        switch ( searchedName ) {

        case 'factoryCode': return this.state.factory;
        case 'serialNumber': return `${searchedVal.from} - ${searchedVal.to}`;
        case 'buildDate':
        case 'processDate': return `${getDateFormat( searchedVal.from, searchedName )} - ${getDateFormat( searchedVal.to, searchedName )}`;
        case 'buildMonth': return `${getDateFormat( searchedVal.from, searchedName )} - ${getDateFormat( searchedVal.to, searchedName )}`;
        case 'productSeriesIds': return this.state.productSeriesIds;
        case 'productSubSeriesIds': return this.state.productSubSeriesIds;
        case 'baseCodeIds': return this.state.baseCodeIds;
        case 'branchIds': return this.state.branchIds;
        case 'regionCode': return this.state.regionCode;
        case 'factoryClaimTypeIds': return this.state.factoryClaimTypeIds;
        case 'pins':
        case 'pipNumbers':
        case 'claimNumbers':
        case 'partNumber': return this.searchResultHeader( searchedVal );
        case 'supplierId': return this.searchResultHeader( searchedVal );
        case 'partDescription': return searchedVal;
        case 'selectedOptionList': return this.state.selectedOptionList;
        case 'modelCdList': return this.searchResultHeader( searchedVal );
        case 'workOrderNumber': return this.searchResultHeader( searchedVal );
        case 'creditMemoNumber': return this.searchResultHeader( searchedVal );
        default: return searchedVal.toString();

        }


    }


     searchResultHeader = propertyValue => {

         const arr = filterEmpty( propertyValue );
         if ( arr.length > 4 ) {

             return `${arr.length} selected`;

         }
         return arr.join( ', ' );

     }

     searchHeader = propertyValue => {

         const arr = filterEmpty( propertyValue );

         return arr.join( ', ' );

     }

     dismissHandler = () => {

         this.setState( {
             warningAlertOpen: false,
         } );

     }

     render () {

         const errMessage = 'Limited Results Displayed!!! Please Enter Additional/Narrower Search Criteria to get Full Results.';
         const defaultColDef = { resizable: true };
        //  const checkboxColumn = {
        //     headerName: "Select All",
        //     field: "checkbox",
        //     width: 30,
        //     checkboxSelection: true,
        //     headerCheckboxSelection: true,
        // };

        // const columnDefs = [
        //     checkboxColumn,
        //    agcmdlColumnDefinitions,
        // ];


         const items = this.props.editedInputs.map( item => (
             <div className="header-style">
                 <label>{this.props.searchedLabels[item[0]]}</label>
                 <div className="headerResult-style">
                     <span>{this.getSearchedValue( item )}</span>
                 </div>
             </div>
         ) );

         return (
             <div>
                 <section>
                     <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                     {this.props.claimList.length >= 5000 &&
                     this.state.warningAlertOpen === true && (
                         <WarningAlertBar
                             alertTitle="Warning"
                             dismissHandler={this.dismissHandler}
                             // canDismiss={true}
                             // willAutoDismiss={true}
                             // timeoutLength="15000"
                         >
                             {errMessage}
                         </WarningAlertBar>
                     ) }
                     <header>

                         <h2 className="page-header">
                            Claim Search - {this.props.claimList.length} Results
                             <i className="fa fa-refresh result-page-refesh" aria-hidden="true" onClick={this.props.onSubmit} title="Refresh" />
                             <button className="primary-button" onClick={this.onModify.bind( this )} type="button"><span> Edit Search </span></button>
                             <button className="primary-button" onClick={this.onClear.bind( this )} type="button"><span> New Search </span></button>

                        </h2>
                        <h2 className="page-header">
                        <button className="primary-button" onClick={this.onBtExportPDF.bind(this)} type="button"><span> Export to PDF </span></button>
                        <button className="primary-button" onClick={this.onBtExport.bind( this )} type="button"><span> Export to CSV </span></button>

                        </h2>
                         <div className="headerPanel-style">
                             {items}
                         </div>


                     </header>
                     <main>
                         <section className="search-result-panel">
                  
                        
                         {/* <input
                        type="checkbox"
                        onChange={this.onSelectAll.bind(this)}
                        checked={this.state.selectedAll}
                    />
                   */}
                             <div
                                 className="ag-theme-balham ag-theme-popupbg"
                             >
                                 
                                 <AgGridReact
                                     columnDefs={agcmdlColumnDefinitions}
                                     defaultColDef={defaultColDef}
                                     rowData={this.props.claimList}
                                     onGridReady={this.onGridReady}
                                     rowSelection={rowSelection}
                                     handleClick={rowClick}
                                     onCellClicked={this.onClaimClick.bind( this )}
                                     onSelectionChanged={this.onSelectionChanged.bind( this )}
                                     selectedGridRow={this.state.selectedGridRow}
                                     popupParent={document.body}
                                     enableCellTextSelection={true}
                                     onRowSelected={this.onRowCheckboxChanged.bind(this)}
                                 />
                                 
                             </div>
                         </section>
                     </main>
                 </section>
             </div>
         );

     }

}


agcmdldetails.displayName = 'agcmdldetails';
agcmdldetails.propTypes = {
    searchedOptions: PropTypes.object.isRequired,
    claimList: PropTypes.array.isRequired,
    onEditSearch: PropTypes.func.isRequired,
    onNewSearch: PropTypes.func.isRequired,
    getSearchList: PropTypes.func.isRequired,
    searchedLabels: PropTypes.object.isRequired,
    onClaimDetails: PropTypes.func.isRequired,
    editedInputs: PropTypes.array.isRequired,
    updateGridAPI: PropTypes.func.isRequired,
    onToggleDiv: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    showDropDownMenu: PropTypes.bool.isRequired,
    callFrom: PropTypes.string.isRequired,
    busyCounter: PropTypes.bool.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( agcmdldetails );
